const login = {
  title: 'Dobro došli natrag!',
  subtitle: 'Unesite svoj email za nastavak.',
  subtitleCode: 'Unesite kod koji smo poslali na vaš email.',

  email: 'Email',
  emailDescription: 'Poslat ćemo vam email s jednokratnom lozinkom za prijavu.',
  code: 'Kod za potvrdu',
  codeDescription: 'Potražite 8-znamenkasti kod u svom emailu.',

  continue: 'Nastavi',
  verify: 'Potvrdi kod',
  cancel: 'Odustani',
  resend: 'Pošalji ponovno',

  otpTitle: 'Jednokratna lozinka',
  otpSubtitle: 'Unesite kod poslan na vaš email.',
  otpContinue: 'Nastavi',
  sending: 'Slanje...',
  verifying: 'Provjera...',
  back: 'Natrag',
  password: 'Lozinka',

  socialLogin: {
    apple: 'Nastavi s Appleom',
    google: 'Nastavi s Googleom',
  },

  verifyingSignIn: 'Provjera prijave...',
  signInFailed: 'Prijava nije uspjela. Molimo pokušajte ponovno.',

  downloadBanner: {
    title: 'Preuzmite aplikaciju',
    subtitle: 'Koristite Voicefill Medical u izvornoj aplikaciji.',
    cta: 'Preuzmi',
    dismissA11y: 'Zatvori banner',
  },
};

export default login;
